import React from 'react';

export const TermsOfCondition = React.lazy(() => import('./pages/TermsOfUse'));
